import { render, staticRenderFns } from "./StudentLectureList.vue?vue&type=template&id=097f8a44"
import script from "./StudentLectureList.vue?vue&type=script&lang=js"
export * from "./StudentLectureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports